var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// 署名付きCookieのキャッシュ有効時間
const SIGNED_COOKIE_CACHE_EXPIRATION_HOUR = 1;
export class SignedCookieService {
    constructor(apiClient) {
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signedCookieCacheExpirationDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.apiClient = apiClient;
    }
    /*---------- Query ----------*/
    fetchSignedCookies() {
        return __awaiter(this, void 0, void 0, function* () {
            const now = new Date();
            if (this.signedCookieCacheExpirationDate <= now) {
                yield this.apiClient.fetchSignedCookies();
                const cacheExpiration = new Date();
                cacheExpiration.setHours(now.getHours() + SIGNED_COOKIE_CACHE_EXPIRATION_HOUR);
                this.signedCookieCacheExpirationDate = cacheExpiration;
            }
        });
    }
}
